import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { NumberInput } from 'hyperdb-utils';
import { DefaultPrice, SeasonalPricesEditor } from '../RentalRulesetEditor';

const PricesFieldset = ({
  property, objectData, onChange, setSeasonalPriceSynchronisation = null, errorBasePrice = null,
  toggleModalConflict, indexesSeasonsInConflict, showModalConflict = false,
  editedCapacity, onChangePropertyCapacity, onSavePropertyCapacity,
}) => {
  const handleChangePriceRules = (attributeName, field) => {
    const priceRules = { ...objectData.price_rules || {} };
    priceRules[attributeName] = field.value;
    onChange('price_rules', { value: priceRules });
  };
  const handleChangeDefaultPrice = (attributeName, field) => {
    const defaultPrice = { ...objectData.default_price || {} };
    defaultPrice[attributeName] = field.value;
    onChange('default_price', { value: defaultPrice });
  };

  if (property.source_channel && property.source_channel.settings.receive_prices) {
    return (<fieldset><h4>Prices are defined by the channel { property.source_channel.name }</h4></fieldset>);
  }
  return (
    <fieldset>
      {
        property.standard_capacity > 0 && property.maximum_capacity > 0
          ? <Tabs defaultActiveKey={1} id="prices-tabs">
              <Tab eventKey={1} title="Default price">
                <DefaultPrice
                  pricesData={ objectData.default_price || {} }
                  priceRules={ objectData.price_rules || {} }
                  showPayingChildren={ true }
                  onChange={ handleChangeDefaultPrice }
                  onChangePriceRules={ handleChangePriceRules }
                  errorBasePrice={ errorBasePrice } />
              </Tab>
              <Tab eventKey={2} title="Seasons">
                <br/>
                <SeasonalPricesEditor
                  property={ property }
                  prices={ objectData.seasonal_prices || [] }
                  onChange={ onChange.bind(null, 'seasonal_prices') }
                  toggleModalConflict={ toggleModalConflict }
                  indexesSeasonsInConflict={ indexesSeasonsInConflict }
                  showModalConflict={ showModalConflict }
                  setSeasonalPriceSynchronisation={ setSeasonalPriceSynchronisation }
                />
              </Tab>
            </Tabs>
          : <div>
              <h4 className="text-warning"><i className="fas fa-warning"/> Please first inform property's capacity</h4>
                <NumberInput
                  label="Standard Capacity"
                  name="standard_capacity"
                  value={ editedCapacity.standard_capacity }
                  onChange={ onChangePropertyCapacity.bind(null, 'standard_capacity') }
                />
                <NumberInput
                  label="Maximum Capacity"
                  name="maximum_capacity"
                  value={ editedCapacity.maximum_capacity }
                  onChange={ onChangePropertyCapacity.bind(null, 'maximum_capacity') }
                />
                <button
                  type="button"
                  className="btn btn-sm btn-success"
                  disabled={ editedCapacity.standard_capacity <= 0 || editedCapacity.maximum_capacity <= 0 }
                  onClick={ onSavePropertyCapacity }
                >
                  OK
                </button>
            </div>
      }
    </fieldset>
  );
};

export default PricesFieldset;



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/components/RentalRulesetEditor/PricesFieldset.jsx